export default {
  mounted(el: HTMLElement, binding: any) {
    handleMaxLengthDirective(el, binding)
  },
  updated(el: HTMLElement, binding: any) {
    handleMaxLengthDirective(el, binding)
  }
}

function handleMaxLengthDirective(el: HTMLElement, binding: any) {
  if (!(el instanceof HTMLInputElement) && !(el instanceof HTMLTextAreaElement)) return

  const maxLength = binding.value?.max || binding.value
  if (typeof maxLength !== 'number' || maxLength <= 0) return

  const element = el as HTMLInputElement | HTMLTextAreaElement

  element.addEventListener('input', function (e: Event) {
    const target = e.target as HTMLInputElement | HTMLTextAreaElement
    if (target.value.length > maxLength) {
      target.value = target.value.slice(0, maxLength)

      showLengthWarning(target, maxLength)
    }

    updateCounter(target, maxLength)
  })

  // Инициализация счетчика
  initializeCounter(element, maxLength)
}

function showLengthWarning(element: HTMLElement, maxLength: number) {
  // Можно добавить тултип или другое уведомление
  console.warn(`Максимальная длина: ${maxLength} символов`)
}

function initializeCounter(element: HTMLElement, maxLength: number) {
  // Создаем элемент для отображения счетчика
  let counter = element.parentElement?.querySelector('.max-length-counter') as HTMLElement

  if (!counter) {
    counter = document.createElement('div')
    counter.className = 'max-length-counter'
    counter.style.cssText = `
      font-size: 12px;
      color: #666;
      text-align: right;
      margin-top: 4px;
    `
    element.parentElement?.appendChild(counter)
  }

  updateCounter(element, maxLength)
}

function updateCounter(element: HTMLElement, maxLength: number) {
  const counter = element.parentElement?.querySelector('.max-length-counter') as HTMLElement
  if (counter) {
    const currentLength = (element as HTMLInputElement).value.length
    counter.textContent = `${currentLength}/${maxLength}`

    if (currentLength > maxLength * 0.9) {
      counter.style.color = '#ff6b6b'
    } else {
      counter.style.color = '#666'
    }
  }
}
